import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  // faUserPlus,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { NavigationLink } from "navigation-react";

const DashboardContenLeftMenus = () => {
  return (
    <aside className="sidebar">
      <ul className="menu">
        <li>
          <NavigationLink stateKey="dashboardcontent">
            <FontAwesomeIcon icon={faTachometerAlt} className="fontIcon" />
            Dashboard
          </NavigationLink>
        </li>
        <li>
          <NavigationLink stateKey="clientregister">
            <FontAwesomeIcon icon={faUsers} /> Client
          </NavigationLink>
        </li>
      </ul>
    </aside>
  );
};

export default DashboardContenLeftMenus;
